module.exports = __webpack_public_path__ + "static/img/rotate3.86ece31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rotate3.jpg
// module id = t+gQ
// module chunks = 49